module.exports = require("lodash/times");